import ImgGeorge from "../../assets/images/about/George.svg";
import ImgKunal from "../../assets/images/about/Kunal.svg";
import ImgLeslie from "../../assets/images/about/Leslie.svg";
import ImgPaul from "../../assets/images/about/Paul.svg";
import ImgVictor from "../../assets/images/about/Victor.svg";

export const TEAM_DATA = [
  {
    id: 0,
    name: "Victor Hugo Gomez",
    position: "Chief Executive Officer",
    shortPosition: "CEO",
    image: ImgVictor,
    twitter: "",
    linkedin: "",
    description:
      "Victor is our company's co-founder and visionary leader, with a distinguished background in Fintech, including his role as the former Senior Vice President of Ventures for Deutsche Borse Group. His strategic foresight drives our success and growth.",
    direction: "left",
  },
  {
    id: 1,
    name: "Leslie Nicholson",
    position: "Chief Product Officer",
    shortPosition: "CPO",
    image: ImgLeslie,
    twitter: "",
    linkedin: "",
    description:
      "With a 20-year career in the investment industry, Leslie is a seasoned strategist. Her experience as Head of Indexes and ESG Data Products at TMX Group underscores her significant contribution as our Chief Product Officer.",
    direction: "left",
  },
  {
    id: 2,
    name: "George Kuznetsov",
    position: "Chief Operating Officer",
    shortPosition: "COO",
    image: ImgGeorge,
    twitter: "",
    linkedin: "",
    description:
      "George's rich experience spanning data analytics, financial services, and strategic consulting fortifies his role as our Chief Operations Officer. His dynamic, customer-centric leadership is central to our operational excellence.",
    direction: "left",
  },
  {
    id: 3,
    name: "Kunal Dhawan",
    position: "Chief Technology Officer",
    shortPosition: "CTO",
    image: ImgKunal,
    twitter: "",
    linkedin: "",
    description:
      "Kunal is a technology leader with a proven record in the IT industry and an MBA focused on IT Architecture & Strategic Consulting. His relentless pursuit of technological innovation characterizes his role as CTO.",
    direction: "right",
  },
  {
    id: 4,
    name: "Paul Herrera",
    position: "Chief Enterprise Architect",
    shortPosition: "CEA",
    image: ImgPaul,
    twitter: "",
    linkedin: "",
    description:
      "A technologist and quantitative finance passionate, Paul has years of relevant experience in the field. He was VP of Data Analytics at Bitbull Capital, a SFO based Hedge Fund. He also founded Avanti Financial Services, a firm that develops IT infrastructure for institutional investors.",
    direction: "right",
  },
];
